import React, { CSSProperties, useState } from 'react';
import { Select } from 'tea-component';
import { useIntl } from 'umi';

import './index.scss';

interface ISortBySelectorProps {
  onChange: (orderType: string) => void;
  defaultValue?: string;
  style?: CSSProperties;
}

export const OrderTypeMap = {
  likes: 'likes',
  views: 'views',
  time: 'time',
};

function SortBySelector(props: ISortBySelectorProps) {
  const { onChange, defaultValue, style } = props;
  const { formatMessage } = useIntl();

  const [orderType, setOrderType] = useState<any>(defaultValue || OrderTypeMap.time);

  const optionSelectData = [
    {
      text: formatMessage({ id: 'dbi_reports_likes' }),
      value: OrderTypeMap.likes,
    },
    {
      text: formatMessage({ id: 'dbi_reports_upload_time' }),
      value: OrderTypeMap.time,
    },
    {
      text: formatMessage({ id: 'dbi_reports_views' }),
      value: OrderTypeMap.views,
    },
  ];

  const handleChange = (value: any) => {
    setOrderType(value);
    onChange?.(value);
  };

  return (
    <Select
      className="dbi-report-sort-by-selector"
      matchButtonWidth
      appearance="button"
      value={orderType}
      options={optionSelectData}
      onChange={handleChange}
      style={style}
      button={() => (
        <div className="select-button">
          <div className="select-button-text">{formatMessage({ id: 'dbi_sortby' })}</div>
          {optionSelectData.find((e) => e.value === orderType)?.text}
        </div>
      )}
    />
  );
}

export default SortBySelector;
